import { AccessService } from '../services';
import { MyAccountFavoritesRoutes, MyAccountFavoritesTab, MyAccountFavoritesTabId } from '../types';

const tabList: MyAccountFavoritesTab[] = [
  {
    id: MyAccountFavoritesTabId.MY_FAVORITES,
    path: MyAccountFavoritesRoutes.MY_FAVORITES,
    label: 'myFavorites',
    url: `/${MyAccountFavoritesRoutes.BASE}/${MyAccountFavoritesRoutes.MY_FAVORITES}`,
    name: 'favorite lists',
    routerLink: true
  },
  {
    id: MyAccountFavoritesTabId.LAST_PURCHASES,
    label: 'lastPurchases',
    url: `/${MyAccountFavoritesRoutes.LEGACY_COMPANY_LISTS}/${MyAccountFavoritesRoutes.RECENTLY_PURCHASED}`,
    name: 'purchases list',
    enabled: a => a.isLastPurchasesEnabled()
  },
  {
    id: MyAccountFavoritesTabId.RECOMMENDATIONS,
    label: 'recommendations',
    url: `/${MyAccountFavoritesRoutes.LEGACY_COMPANY_LISTS}/${MyAccountFavoritesRoutes.RECOMMENDED_PRODUCTS}`,
    name: 'recommendations list',
    enabled: a => a.isRecommendationsEnabled()
  },
  {
    id: MyAccountFavoritesTabId.COMPANY_LIST,
    label: 'companyFavorites',
    url: `/${MyAccountFavoritesRoutes.LEGACY_COMPANY_LISTS}`,
    name: 'company lists'
  },
  {
    id: MyAccountFavoritesTabId.SUBMITTALS,
    label: 'submittals',
    url: `/${MyAccountFavoritesRoutes.SUBMITTALS}`,
    name: 'submittals',
    enabled: a => a.isSubmittalsEnabled()
  }
];

const tabListForHeadlessCompanyListFeature: MyAccountFavoritesTab[] = [
  {
    id: MyAccountFavoritesTabId.MY_FAVORITES,
    path: MyAccountFavoritesRoutes.MY_FAVORITES,
    label: 'myFavorites',
    url: `/${MyAccountFavoritesRoutes.BASE}/${MyAccountFavoritesRoutes.MY_FAVORITES}`,
    name: 'favorite lists',
    routerLink: true
  },
  {
    id: MyAccountFavoritesTabId.COMPANY_LIST,
    path: MyAccountFavoritesRoutes.COMPANY_LIST,
    label: 'companyFavorites',
    url: `/${MyAccountFavoritesRoutes.BASE}/${MyAccountFavoritesRoutes.COMPANY_LIST}`,
    name: 'company lists',
    routerLink: true
  },
  {
    id: MyAccountFavoritesTabId.RECOMMENDATIONS,
    label: 'recommendations',
    url: `/${MyAccountFavoritesRoutes.LEGACY_COMPANY_LISTS}/${MyAccountFavoritesRoutes.RECOMMENDED_PRODUCTS}`,
    name: 'recommendations list',
    enabled: a => a.isRecommendationsEnabled()
  },
  {
    id: MyAccountFavoritesTabId.LAST_PURCHASES,
    label: 'lastPurchases',
    url: `/${MyAccountFavoritesRoutes.LEGACY_COMPANY_LISTS}/${MyAccountFavoritesRoutes.RECENTLY_PURCHASED}`,
    name: 'purchases list',
    enabled: a => a.isLastPurchasesEnabled()
  },
  {
    id: MyAccountFavoritesTabId.SUBMITTALS,
    label: 'submittals',
    url: `/${MyAccountFavoritesRoutes.SUBMITTALS}`,
    name: 'submittals',
    enabled: a => a.isSubmittalsEnabled()
  }
];

export function getNavigationTabs(
  headlessCompanyListEnabled: boolean,
  accessService?: AccessService
): MyAccountFavoritesTab[] {
  let finalTabList = tabList;
  if (headlessCompanyListEnabled) {
    finalTabList = tabListForHeadlessCompanyListFeature;
  }
  return finalTabList.filter(tab => !accessService || !tab.enabled || tab.enabled(accessService));
}
